import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Divider } from '@material-ui/core'
import SpecificComponent from '../../commons/SpecificComponent';
import FileIcon from '../../providers/FileIcon';
import Ws from '../../providers/Ws';
import generic from '../../Pics/iconsMonitorizare/generic.png'






export default class EditEticheta extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listProductive: [
                { nume: 'Nu', id: 0 },
                { nume: 'Da', id: 1 }
            ]
        }
    }

    componentDidMount() {

    }

    ws = new Ws()




    render() {
        console.log('eticheteAll :>> ', this.props.eticheteAll);
        return (


            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'sm'}
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container>



                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                <Grid container>

                                    <Grid item item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <div
                                            style={{ display: 'inline-block', marginRight: 20, verticalAlign: 'middle' }}
                                        >
                                            <img

                                                style={{ margin: 0, width: 30, height: 30 }}
                                                src={this.props.aplicatie.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${this.props.aplicatie.icon}` : generic}
                                            />

                                        </div>
                                    </Grid>
                                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                        <Grid container>
                                            <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <span style={{ marginRight: 20, fontSize: 18, display: 'block', fontWeight: 600 }}>{this.props.aplicatie.app_name}</span>
                                            </Grid>

                                            <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block' }}>{this.props.aplicatie.details}</span>
                                            </Grid>
                                        </Grid>

                                    </Grid>


                                </Grid>

                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='eticheta'
                                                type="text"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='eticheta'
                                                value={this.props.aplicatie.eticheta || ''}
                                                onChange={this.props.changeAplicatie}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.monitorizare.eticheta}</label>
                                        </div>

                                    </Grid>

                                    {this.props.eticheteAll.map((etc, idx) => {
                                        return (
                                            <Grid key={idx} style={{
                                                paddingLeft: 10,
                                                marginTop: 5,
                                                paddingBottom: 5
                                            }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid container>

                                                    <Grid style={{ textAlign: 'left' }} item xs={11} sm={11} md={11} lg={11} xl={11}>

                                                        <div style={{ fontWeight: 600 }}>



                                                            <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {etc.eticheta} </span><br />

                                                        </div>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'left' }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        <i onClick={() => { this.props.addEticheta(etc.eticheta) }}
                                                            style={{ fontSize: 20, verticalAlign: 'sub', cursor:'pointer' }}
                                                            className='material-icons '> add_circle_outline</i>
                                                    </Grid>
                                                </Grid>
                                                <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                            </Grid>
                                        )
                                    })}






                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-green'} onClick={() => { this.props.salveazaAplicatie() }}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>add</i>  {this.dictionary.monitorizare.salveaza}
                                        </Button>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </DialogContent>

                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}
                    {/* <DialogActions className="pm-dialog-bottom-buttons">




                    </DialogActions> */}


                </Dialog>
            </div>
        );
    }
}